export const mimeTypes = {
  Pdf: {
    title: '.pdf',
    type: 'application/pdf'
  },
  Docx: {
    title: '.docx',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  },
  Txt: {
    title: '.txt',
    type: 'text/plain'
  },
  Sig: {
    title: '.sig',
    type: '.sig'
  },
  Xls: {
    title: '.xls',
    type: 'application/vnd.ms-excel'
  },
  Xlsx: {
    title: '.xlsx',
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }
};